<template>

  <div>
    <vx-card>
      <a-tabs @change="handleTabChange">
        <a-tab-pane tab="Task Progress" :key="1">
          <a-form :form="formProgress" @submit.prevent="handleReportProgress">
            <div class="grid grid-cols-1 w-full md:w-1/2">
              <SelectOption
                url="/account/list/"
                label="User"
                field="user"
                mode="multiple"
                :required="false"
                method="get"
                placeholder="Find A User"
                class="w-full self-end"
              />
              <div class="flex flex-col md:flex-row">
                <selectSearch
                  :required="false"
                  url="/matter/query/"
                  :options="optionSearchMatter"
                  class="self-end mt-8 md:mt-0 w-full"
                  :is_include_matter="true"
                  @selectSearch="handleSearch"
                />
                <!--<selectSearch-->
                <!--v-if="checked_matter_client_progress === 2"-->
                <!--:required="true"-->
                <!--url="/contact/query/"-->
                <!--:options="optionSearchContact"-->
                <!--class="self-center mt-8 md:mt-0 w-full"-->
                <!--:is_include_matter="false"-->
                <!--@selectSearch="handleSearch"-->
                <!--/>-->
              </div>
              <a-form-item label="Task type">
                <a-select v-decorator="['task_status',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]">
                  <a-select-option :value="1">
                    All
                  </a-select-option>
                  <a-select-option :value="2">
                    In progress
                  </a-select-option>
                  <a-select-option :value="3">
                    In review
                  </a-select-option>
                  <a-select-option :value="4">
                    Complete
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Select Date Range">
                <a-select v-decorator="['period_date',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]">
                  <a-select-option :value="1">
                    All Dates
                  </a-select-option>
                  <a-select-option :value="2">
                    This Year
                  </a-select-option>
                  <a-select-option :value="3">
                    This Quarter
                  </a-select-option>
                  <a-select-option :value="4">
                    This Month
                  </a-select-option>
                  <a-select-option :value="5">
                    This Week
                  </a-select-option>
                  <a-select-option :value="6">
                    Today
                  </a-select-option>
                  <a-select-option :value="7">
                    Last 12 Months
                  </a-select-option>
                  <a-select-option :value="8">
                    Last 3 Months
                  </a-select-option>
                  <a-select-option :value="9">
                    Last 30 Days
                  </a-select-option>
                  <a-select-option :value="10">
                    Last 7 Days
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <a-divider/>
            <a-button type="primary"
                      :loading="loading"
                      html-type="submit"
                      style="border-radius: 3px !important"
            >
              Generate Report
            </a-button>
          </a-form>
        </a-tab-pane>
        <a-tab-pane tab="Task Productivity" :key="2">
          <a-form :form="formProductivity" @submit.prevent="handleGeneralReport">
            <div class="grid grid-cols-1 w-full md:w-1/2">
              <SelectOption
                url="/account/list/"
                label="User"
                field="user"
                mode="multiple"
                :required="false"
                method="get"
                placeholder="Find A User"
                class="w-full self-end"
              />
              <div class="flex flex-col md:flex-row">
                <selectSearch
                  :required="false"
                  url="/matter/query/"
                  :options="optionSearchMatter"
                  class="self-end mt-8 md:mt-0 w-full"
                  :is_include_matter="true"
                  @selectSearch="handleSearch"
                />
                <!--<selectSearch-->
                <!--v-if="checked_matter_client_progress === 2"-->
                <!--:required="true"-->
                <!--url="/contact/query/"-->
                <!--:options="optionSearchContact"-->
                <!--class="self-center mt-8 md:mt-0 w-full"-->
                <!--:is_include_matter="false"-->
                <!--@selectSearch="handleSearch"-->
                <!--/>-->
              </div>
              <a-form-item label="Task type">
                <a-select v-decorator="['task_status',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]">
                  <a-select-option :value="1">
                    All
                  </a-select-option>
                  <a-select-option :value="2">
                    In progress
                  </a-select-option>
                  <a-select-option :value="3">
                    In review
                  </a-select-option>
                  <a-select-option :value="4">
                    Complete
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Select Date Range">
                <a-select v-decorator="['period_date',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]">
                  <a-select-option :value="1">
                    All Dates
                  </a-select-option>
                  <a-select-option :value="2">
                    This Year
                  </a-select-option>
                  <a-select-option :value="3">
                    This Quarter
                  </a-select-option>
                  <a-select-option :value="4">
                    This Month
                  </a-select-option>
                  <a-select-option :value="5">
                    This Week
                  </a-select-option>
                  <a-select-option :value="6">
                    Today
                  </a-select-option>
                  <a-select-option :value="7">
                    Last 12 Months
                  </a-select-option>
                  <a-select-option :value="8">
                    Last 3 Months
                  </a-select-option>
                  <a-select-option :value="9">
                    Last 30 Days
                  </a-select-option>
                  <a-select-option :value="10">
                    Last 7 Days
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <a-divider/>
            <a-button type="primary"
                      :loading="loading"
                      html-type="submit"
                      style="border-radius: 3px !important"
            >
              Generate Report
            </a-button>
          </a-form>
        </a-tab-pane>
      </a-tabs>
    </vx-card>
    <a-modal centered :visible="open_progress_user" width="70%" title="Task Report" @cancel="open_progress_user = false">
      <XTable
        v-if="tab_value_key === 1"
        :model="model_progress"
        method="get"
        ref="task_status"
        :is_pagenation="false"
        :search="false"
        :options="{placeholder:'Search task progress',noContent: 'No tasks progress',is_row_selection: false,is_load_req: false}"
      >
        <div slot="user" slot-scope="text,record" >
          <template v-if="text.record.user">
            {{ text.record.user.first_name }} {{ text.record.user.last_name }}
          </template>
        </div>
        <div class="inline-grid" slot="pending" slot-scope="text,record" >
          <template v-if="text.record.pending">
            {{ text.record.pending.status__count }}
            <small>{{ (text.record.pending.time_estimate__sum || 0) + 'h Time Estimate' }}</small>
          </template>
        </div>
        <div class="inline-grid" slot="progress" slot-scope="text,record" >
          <template v-if="text.record.progress">
            {{ text.record.progress.status__count }}
            <small>{{ (text.record.progress.time_estimate__sum || 0) + 'h Time Estimate' }}</small>
          </template>
        </div>
        <div class="inline-grid" slot="review" slot-scope="text,record" >
          <template v-if="text.record.review">
            {{ text.record.review.status__count }}
            <small>{{ (text.record.review.time_estimate__sum || 0) + 'h Time Estimate' }}</small>
          </template>
        </div>
        <div class="inline-grid" slot="complete" slot-scope="text,record" >
          <template v-if="text.record.complete">
            {{ text.record.complete.status__count }}
            <small>{{ (text.record.complete.time_estimate__sum || 0) + 'h Time Estimate' }}</small>
          </template>
        </div>
        <div slot="total" slot-scope="text,record">
          {{ totalTask(text.record) }}
        </div>
      </XTable>
      <XTable
        v-else
        :model="model_productivity"
        method="get"
        ref="task"
        :is_pagenation="false"
        :search="false"
        :options="{placeholder:'Search Task Productivity',noContent: 'No Tasks Productivity',is_row_selection: false,is_load_req: false}"
      >
        <div slot="user" slot-scope="text,record" >
          <template v-if="text.record.user">
            {{ text.record.user.first_name }} {{ text.record.user.last_name }}
          </template>
        </div>
        <div class="inline-grid" slot="upcoming" slot-scope="text,record" >
          <template v-if="text.record.next">
            {{ text.record.next.status__count }}
            <small>{{ (text.record.next.time_estimate__sum || 0) + 'h Time Estimate' }}</small>
          </template>
        </div>
        <div class="inline-grid" slot="overdue" slot-scope="text,record" >
          <template v-if="text.record.past">
            {{ text.record.past.status__count }}
            <small>{{ (text.record.past.time_estimate__sum || 0) + 'h Time Estimate' }}</small>
          </template>
        </div>
        <div class="inline-grid" slot="complete" slot-scope="text,record" >
          <template v-if="text.record.complete">
            {{ text.record.complete.status__count }}
            <small>{{ (text.record.complete.time_estimate__sum || 0) + 'h Time Estimate' }}</small>
          </template>
        </div>
      </XTable>
    </a-modal>
  </div>

</template>

<script>
import XTable from '../../../components/x-table/XTable'
import * as TableColTaskProductivity from './tbl_productivity'
import * as TableColTaskProgress from './tbl_progress'
import SelectOption from "../../forms/SelectOptionSingle"
import selectSearch from "@/views/forms/selectSearch";
import axios from '@/axios'
import mixin from '../../mixin/mixin'

export default {
  name: "TaskReport",
  mixins:[mixin],
  components:{
    XTable,
    TableColTaskProductivity,
    TableColTaskProgress,
    SelectOption,
    selectSearch
  },
  data(){
    return{
      formProgress          : this.$form.createForm(this, {name: 'coordinated'}),
      formProductivity      : this.$form.createForm(this, {name: 'coordinated'}),
      open_progress_user    : false,
      open_productivity_user: false,
      loading               : false,
      model_progress        : null,
      model_productivity    : null,
      tab_value_key         : 1
    }
  },
  methods:{
    totalTask(record){
      const pending  = record.pending  ? record.pending.status__count  : 0
      const progress = record.progress ? record.progress.status__count : 0
      const review   = record.review   ? record.review.status__count   : 0
      const complete = record.complete ? record.complete.status__count : 0
      return pending + progress + review + complete
    },

    setMattersTasks(model){
      return Object.values(model).map(item=>item).filter(({matter})=> matter !== null)
    },

    handleGeneralReport(){
      this.formProductivity.validateFields(async (err)=>{
        if(!err){
          try{
            this.loading = true
            const {data} = await axios.get('report/stats/task')
            this.open_progress_user = true
            this.$nextTick(()=>this.$refs['task'].data = data.result)
          }catch (e) {
            this.$notification['error']({
              message:'Failed',
              description:'Server error'
            })
            throw e
          }finally {
            this.loading = false
          }
        }
      })
    },

    handleReportProgress(){
      this.formProgress.validateFields(async(err)=>{
        if(!err){
          try{
            this.loading = true
            const {data} = await axios.get('/report/stats/task-status')
            this.open_progress_user = true
            this.$nextTick(()=>this.$refs['task_status'].data = data.result)
          }catch (e) {
            this.$message.error('Server error')
            throw e
          }finally {
            this.loading = false
          }
        }
      })
    },

    handleTabChange(key){
      this.tab_value_key = key
    }

  },
  created() {
    this.model_progress     = TableColTaskProgress.default
    this.model_productivity = TableColTaskProductivity.default
  },
}
</script>

<style scoped>

</style>
